/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-card-content[_ngcontent-%COMP%]{padding-top:20px}.cards[_ngcontent-%COMP%]{display:flex}mat-card[_ngcontent-%COMP%]{margin-bottom:20px}.compose-section[_ngcontent-%COMP%], .management-section[_ngcontent-%COMP%]{margin:20px;flex:1}.summary[_ngcontent-%COMP%]{width:100%}.summary[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(2){width:150px;text-align:right}.test-mail-addresses[_ngcontent-%COMP%]{height:100px}"];
export { styles as styles };
